const ONLOAD_CALLBACK = "onMeidlyRecaptchaLoad";

export const Recaptcha = {
  SITE_KEY: process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY ?? "",
  ONLOAD_CALLBACK,
  SCRIPT_URL: `https://www.google.com/recaptcha/api.js?render=explicit&onload=${ONLOAD_CALLBACK}`,
  IDLE_PRELOAD_TIMEOUT_MS: 3000,
  PRECONNECT_ORIGINS: ["https://www.google.com", "https://www.gstatic.com"],
  VERIFY_URL: "https://www.google.com/recaptcha/api/siteverify",
} as const;
